import script from "./aiMessageDisplayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./aiMessageDisplayer.vue?vue&type=script&setup=true&lang=ts"

import "./aiMessageDisplayer.vue?vue&type=style&index=0&id=12d6fb56&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d6fb56"]])

export default __exports__